/**
 * Enum of possible user roles
 */
export enum UserRoleEnum {
  EXECUTIVE_ADMIN = 'Executive Admin',
  COORDINATOR = 'Coordinator',
  CUSTOMER_ADMIN = 'Customer Admin',
  CUSTOMER_COORDINATOR = 'Customer Coordinator',
  ACCOUNTING = 'Accounting',
  DRIVER = 'Driver',
  MANAGEMENT = 'Management',
  VENDOR_ADMIN = 'Vendor Admin',
  VENDOR_COORDINATOR = 'Vendor Coordinator',
  VENDOR_DRIVER = 'Vendor Driver',
  INTERNAL_READONLY = 'Internal Read Only',
  OUTSIDE_ORG = 'OutSideOrg',
}
